import { create } from "zustand";
import { getClientsData } from "../api/apiClient";

const useClientsStore = create((set, get) => ({
  clients: [],
  isLoading: false,
  isLoaded: false,
  error: null,

  fetchClients: async () => {
    if (get().isLoading) return;

    set({ isLoading: true, error: null });
    try {
      const res = await getClientsData();

      if (Array.isArray(res)) {
        set({ clients: res, isLoaded: true, isLoading: false });
      } else if (res?.success === false) {
        set({
          clients: [],
          isLoaded: true,
          isLoading: false,
          error: res.message,
        });
      } else {
        set({ clients: [], isLoaded: true, isLoading: false });
      }
    } catch (error) {
      set({ clients: [], isLoading: false, error: error.message });
    }
  },

  refreshClients: async () => {
    set({ isLoaded: false });
    await get().fetchClients();
  },

  clearClients: () => {
    set({ clients: [], isLoading: false, isLoaded: false, error: null });
  },
}));

export default useClientsStore;
